import axios from "axios";

const prepareData = (data) => {
  return { store_request: data };
};

export const GET_STORE_REQUESTS = "get_store_requests";
export const getStoreRequests = () => {
  const request = axios.get("/store/requests.json");
  return { type: GET_STORE_REQUESTS, payload: request };
};

export const GET_STORE_REQUEST = "get_store_request";
export const getStoreRequest = (id) => {
  const request = axios.get(`/store/requests/${id}.json`);
  return { type: GET_STORE_REQUEST, payload: request };
};

export const CREATE_STORE_REQUEST = "create_store_request";
export const createStoreRequest = (data) => {
  const request = axios({ method: "post", url: "/store/requests.json", data: prepareData(data) });
  return { type: CREATE_STORE_REQUEST, payload: request };
};

export const UPDATE_STORE_REQUEST = "update_store_request";
export const updateStoreRequest = (id, data) => {
  const request = axios({ method: "patch", url: `/store/requests/${id}.json`, data: prepareData(data) });
  return { type: UPDATE_STORE_REQUEST, payload: request };
};

export const DESTROY_STORE_REQUEST = "destroy_store_request";
export const destroyStoreRequest = (id) => {
  const request = axios({ method: "delete", url: `/store/requests/${id}.json` });
  return { type: DESTROY_STORE_REQUEST, payload: request, meta: { id } };
};

const memberPost = (type, id, path, data = {}) => {
  const request = axios({ method: "post", url: `/store/requests/${id}/${path}.json`, data: prepareData(data) });
  return { type, payload: request };
};

export const SEND_STORE_REQUEST_FOR_APPROVAL = "send_store_request_for_approval";
export const sendStoreRequestForApproval = (id) => memberPost(SEND_STORE_REQUEST_FOR_APPROVAL, id, "send_for_approval");

export const APPROVE_STORE_REQUEST = "approve_store_request";
export const approveStoreRequest = (id) => memberPost(APPROVE_STORE_REQUEST, id, "approve");

export const REJECT_STORE_REQUEST = "reject_store_request";
export const rejectStoreRequest = (id) => memberPost(REJECT_STORE_REQUEST, id, "reject");

export const CREATE_STORE_REQUEST_PO = "create_store_request_po";
export const createStoreRequestPo = (id, data) => memberPost(CREATE_STORE_REQUEST_PO, id, "create_po", data);

export const MARK_STORE_REQUEST_ORDERED = "mark_store_request_ordered";
export const markStoreRequestOrdered = (id) => memberPost(MARK_STORE_REQUEST_ORDERED, id, "mark_ordered");

export const MARK_STORE_REQUEST_IN_STORE = "mark_store_request_in_store";
export const markStoreRequestInStore = (id) => memberPost(MARK_STORE_REQUEST_IN_STORE, id, "mark_in_store");

export const COMPLETE_STORE_REQUEST = "complete_store_request";
export const completeStoreRequest = (id) => memberPost(COMPLETE_STORE_REQUEST, id, "complete");

export const CANCEL_STORE_REQUEST = "cancel_store_request";
export const cancelStoreRequest = (id) => memberPost(CANCEL_STORE_REQUEST, id, "cancel");

export const downloadStoreRequestOrderEml = async (id) => {
  const response = await axios.get(`/store/requests/${id}/download_order_eml.json`);
  const { filename, eml } = response.data;
  const blob = new Blob([eml], { type: "message/rfc822" });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename || `PO-${id}.eml`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
  return response.data;
};
